"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _localeCurrency = require("./localeCurrency.model");
var _constant = require("./constant");
var LocaleCurrencyUtils = {
  generateDropdownOptionsData: function generateDropdownOptionsData(localeObj, currencyObj) {
    var showLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var showCurrency = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var localeList = arguments.length > 4 ? arguments[4] : undefined;
    var currencyList = arguments.length > 5 ? arguments[5] : undefined;
    if (!localeObj || !currencyObj) {
      return [];
    }
    var optionsArray = [];
    if (showLocale) {
      var locale = new _localeCurrency.DropdownOptionsData(_constant.LOCALE_CURRENCY_DEFAULTS.ICONS.LOCALE, localeObj.longform, _constant.DROPDOWN_VALUES.LOCALE, Boolean(localeList && localeList.length > 1));
      optionsArray.push(locale);
    }
    if (showCurrency) {
      var currencyText = currencyObj.shortSymbol ? "".concat(currencyObj.shortform, " ").concat(currencyObj.shortSymbol) : "".concat(currencyObj.shortform);
      var currency = new _localeCurrency.DropdownOptionsData(_constant.LOCALE_CURRENCY_DEFAULTS.ICONS.CURRENCY, currencyText, _constant.DROPDOWN_VALUES.CURRENCY, Boolean(currencyList && currencyList.length > 1));
      optionsArray.push(currency);
    }
    return optionsArray;
  },
  generateCurrencyList: function generateCurrencyList() {
    var currencyArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currencyList = [];
    currencyArr.forEach(function (curr) {
      var subtitle = curr.shortSymbol ? "".concat(curr.shortform, " - ").concat(curr.shortSymbol) : "".concat(curr.shortform);
      var newCurrency = new _localeCurrency.TileGroupData(curr.longform, subtitle, curr.shortform);
      currencyList.push(newCurrency);
    });
    return currencyList;
  },
  generateLocaleList: function generateLocaleList() {
    var localeArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var localeList = [];
    localeArr.forEach(function (locale) {
      var newCurrency = new _localeCurrency.TileGroupData(locale.longform, null, locale.default);
      localeList.push(newCurrency);
    });
    return localeList;
  },
  getLocaleByDefault: function getLocaleByDefault(val) {
    var localeList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var localeObj = localeList.find(function (loc) {
      return loc.default.toLowerCase() === val.toLowerCase();
    });
    if (localeObj) {
      return localeObj;
    }
    return _constant.LOCALE_CURRENCY_DEFAULTS.LOCALE_OBJ;
  },
  getCurrencyByShortform: function getCurrencyByShortform(val) {
    var currencyList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var currencyObj = currencyList.find(function (curr) {
      return curr.shortform.toLowerCase() === val.toLowerCase();
    });
    if (currencyObj) {
      return currencyObj;
    }
    return _constant.LOCALE_CURRENCY_DEFAULTS.CURRENCY_OBJ;
  },
  getSingleLocaleDefault: function getSingleLocaleDefault(localeList, defaultLocale) {
    if (localeList.length >= 2) {
      var localeObj = localeList.find(function (loc) {
        return loc.default === defaultLocale;
      });
      if (!localeObj) {
        var defaultLocaleObj = localeList.find(function (loc) {
          return loc.default === _constant.LOCALE_CURRENCY_DEFAULTS.LOCALE_OBJ.default;
        });
        if (defaultLocaleObj) {
          return defaultLocaleObj.default;
        }
        return localeList[0].default;
      }
      return localeObj.default;
    }
    return localeList[0].default;
  },
  getSingleCurrencyShortform: function getSingleCurrencyShortform(currencyList, defaultCurrency) {
    if (currencyList.length >= 2) {
      var defaultVal = currencyList.find(function (loc) {
        return loc.shortform === defaultCurrency;
      });
      if (!defaultVal) {
        var defaultCurrencyObj = currencyList.find(function (cur) {
          return cur.shortform === _constant.LOCALE_CURRENCY_DEFAULTS.CURRENCY_OBJ.shortform;
        });
        if (defaultCurrencyObj) {
          return defaultCurrencyObj.shortform;
        }
        return currencyList[0].shortform;
      }
      return defaultVal.shortform;
    }
    return currencyList[0].shortform;
  }
};
var _default = LocaleCurrencyUtils;
exports.default = _default;